// removed by extract-text-webpack-plugin
module.exports = {"classDay":"src-components-ClassDay__classDay--3evkS","date":"src-components-ClassDay__date--3cQAI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClassDay.scss
// module id = 73
// module chunks = 0